import { IBreadcrumb } from './../breadcrumb/breadcrumb.interface';
import { BreadcrumbService } from './../services/breadcrumb.service';
import { CommonService } from './../services/common.service';
import { ShoppingCartService } from './../services/shopping-cart.service';
import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
  ComponentRef,
  ElementRef
} from '@angular/core';
import { slideIn, disappear } from '../shared/animations.collections';
import { ActivatedRoute, Router, NavigationEnd, Params } from '@angular/router';
// import 'rxjs/add/observable/from';
import { SearchService } from '../services/search.service';
import { MarketingService } from '../services/marketing.service';
import { Promotion } from '../models/marketing.model';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
// tslint:disable-next-line:import-blacklist
import { Observable, Subject, of } from 'rxjs';
import { getProductSearch, productBrands, productTypes, productCategories, productSeries, prontoBrands } from '../models/filter.model';
import { BrandListReturn, MetaModel } from '../models/search-brand-result.model';
import { getStockOnHand } from '../shared/tools.collections';
import { MessageService } from '../services/message.service';
import { TablefilterMultiplePipe } from '../shared/pipes/tablefilter-multiple.pipe';
import { SendEnquiryComponent } from '../popup-collection/send-enquiry/send-enquiry.component';
import { Store } from '@ngrx/store';
import { AppState } from '../reducers';
import { getSelectedShoppingCart } from '../reducers/shoppingcart.reducer';
import { InsertShoppingCartItem, ShoppingCartActionTypes } from '../actions/shoppingcart.actions';
import { catchError, debounceTime, distinctUntilChanged, filter, map, shareReplay, switchMap, takeUntil, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { combineLatest } from 'rxjs';
import { FormControl } from '@angular/forms';
import { Location } from '@angular/common';
import { ofType, Actions } from '@ngrx/effects';
import { AuthService } from '../services/auth.service';
import { CurrentUserModel } from '../models/account-ledger.model';
import { MatDialog } from '@angular/material/dialog';
import { Sort } from '@angular/material/sort';

declare var $: any;
declare var require: any;

interface ISearch {
  isGlobalSearch: boolean,
  searchfield: string,
  type: string[],
  brand: string[],
  category: string[],
  series: string[],
}

interface ISearchResult {
  searchType: string,
  keyword: string,
  types: productTypes[],
  brands: productBrands[],
  categories: productCategories[],
  series: productSeries[],
  selectedCategories: string[],
  selectedSeries: string[],
  selectedBrands: string[],
  selectedTypes: string[],

  allProductTypes: productTypes[],
  allBrands: prontoBrands[],
  fullBrands: productBrands[]
}

@Component({
  selector: 'app-manage-store',
  templateUrl: './buy.page.component.html',
  styleUrls: ['./buy.page.component.css'],
  animations: [slideIn, disappear]
})
export class BuyPageComponent implements OnInit, OnDestroy {

  appVersion: string = require('../../../package.json').version;

  title = 'Search Products';
  created = false;
  currentUserModel: CurrentUserModel;
  // Declare filter variables
  brands: productBrands[] = [];
  selectedBrands = [];
  types: productTypes[] = [];
  selectedTypes: any = [];
  selectedBrandName = '';
  selectedTypeName = '';
  selectedBrandsString = '';
  selectedTypesString = '';
  selectedCategoriesString = '';
  selectedSeriesString = '';
  categories: productCategories[] = [];
  selectedCategories = [];
  serieses: productSeries[] = [];
  selectedSeriese = [];

  allProductTypes: productTypes[] = [];
  allBrands: prontoBrands[] = [];
  fullBrands: productBrands[] = [];
  typeSearchField = '';
  brandSearchField = '';
  breadcrumbItems: IBreadcrumb[] = [];

  // filter params
  filterInput = '';
  brandsParam = '';
  typesParam = '';
  catsParam = '';
  seriesParam = '';
  minPrice: number;
  maxPrice: number;
  minSOH: number;
  excludeKits = false;

  loadContent = false;
  showResultPage = false;
  showProductTypesPage = false;
  showVendorsPage = false;
  isBrowseByVendor = false;

  hasEmptyResult = true;
  searchProductClicked = false;
  globallySearch = false;
  hasEmptyFilterResult = false;
  showFilter = true;
  selectedViewOption = 'compact';

  // filter loading status
  showBrandLoading = false;
  showTypeLoading = false;
  showCategoryLoading = false;
  showSeriesLoading = false;
  showResultDownloading = false;

  searchResult: BrandListReturn[] = [];
  metaData: MetaModel;
  sortedData: any[] = [];
  withoutBundleData: BrandListReturn[] = [];


  isWithoutBundle: boolean = true;
  isShowWithStock: boolean = false;

  inputQty = '1';
  inputQtyArr: { [K: string]: string } = {};
  cartId: number;
  addingItemId: string = '';
  downloadLink = '';

  // unsubscribe
  ngUnsubscribe: Subject<void> = new Subject<void>();


  @ViewChild('entry', { read: ViewContainerRef })
  entry: ViewContainerRef;
  component: ComponentRef<any>;

  // css variable
  setFullWindow = false;
  subWidth: string;

  searchField = '';
  searchedKeyword = '';

  offsetWidth = 2;

  bannerInterval = 25;
  bannerCount = 0;
  bannerList: Promotion[] = [];
  // randomBanners: Promotion[] = [];

  keywordSubject: Subject<string> = new Subject();

  qantasRewardsMessage = 'This product is eligible for the Qantas Business Rewards program';
  airpointRewardsMessage = 'This product is eligible for the Airpoints for Business program';

  @ViewChild(BreadcrumbComponent, { static: true }) breadcrumbRef: BreadcrumbComponent; // reference to the breadcrumb
  @ViewChild("ParentWrapper", { static: true }) parentWrapper: ElementRef;
  selectedSortOrder : any = null;
  constructor(
    private _router: Router,
    private cs: CommonService,
    private activeRouter: ActivatedRoute,
    private router: Router,
    private searchService: SearchService,
    private marketingService: MarketingService,
    private shoppingCartService: ShoppingCartService,
    private commonService: CommonService,
    private messageService: MessageService,
    private breadcrumbService: BreadcrumbService,
    public dialog: MatDialog,
    private store: Store<AppState>,
    private _actions$: Actions,
    private http: HttpClient,
    private location: Location,
    private authService: AuthService
  ) {
    this.commonService.emitUpdateSideBarActiveItem('search');
  }

  ngOnInit() {
    this.authService.getLoginInfo().pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: CurrentUserModel) => {
        this.currentUserModel = res;
      }, (error: any) => {
        console.error(error);
      });

    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(res => {
      if (this.breadcrumbRef) {
        this.breadcrumbRef.ngAfterViewInit();
      }
    });

    this.keywordSubject.asObservable().pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
      this.updateFilterList('keyword');
    });

    //product type and brands all list observable
    const allproductType$: Observable<productTypes[]> = this.searchService.getProductSearch('', '', '', '', '', 'type').pipe(
      map((value) => value.map((item) => {
        const type = {} as productTypes;
        type.out_type_code = item.out_type_code;
        type.out_type_description = item.out_type_description;
        type.type_description_with_cnt = `${item.out_type_description} (${item.cnt})`;
        type.cnt = item.cnt;
        //type.logo = `../images/new_ui/product-types/${item.out_type_description.replace(' ', '_')}.PNG?t=${this.appVersion}`;
        type.logo = `../images/new_ui/product-types/${item.out_type_description.split(' ').join('_')}.PNG?t=${this.appVersion}`;
        //  if (item.out_type_description.includes('BAGS')) {
        //     type.logo = '../images/new_ui/product-types/BAGS.png';
        //   }

        // if (this.currentUserModel.isAU == true) {
        //   if (item.out_type_description.includes('MONITORS')) {
        //     type.logo = '../images/new_ui/product-types/MONITORS.png';
        //   }
        // }

        // if (item.out_type_description.includes('HEALTH')) {
        //  type.logo = '../images/new_ui/product-types/HEALTH_AND_WEARABLES.png';
        // } 


        return type;
      })
    ));

    const allbrandType$: Observable<prontoBrands[]> = this.searchService.getBrandList();

    const brands$: Observable<{ fullbrands: productBrands[], allbrands: prontoBrands[] }> = allbrandType$.pipe(
      switchMap((allbrands) => {
        return this.searchService.getProductSearch('', '', '', '', '', 'brand').pipe(
          map((fullbrands) => {
            const full_Brands = fullbrands.map(item => {
              const brand = {} as productBrands;
              brand.out_brand_code = item.out_brand_code;
              brand.out_brand_description = item.out_brand_description;
              brand.brand_description_with_cnt = `${item.out_brand_description} (${item.cnt})`;
              brand.cnt = item.cnt;
              return brand;
            });
            const all_brands = allbrands.map(item => {
              item.lrBrandImageUrl = `${item.lrBrandImageUrl}`;
              if (fullbrands.filter(i => i.out_brand_code === item.lrBrand).length > 0) {
                item.count = fullbrands.filter(i => i.out_brand_code === item.lrBrand)[0].cnt;
              } else {
                item.count = '0';
              }
              return item;
            });
            return {
              fullbrands: full_Brands,
              allbrands: all_brands
            };
          })
        );
      })
    );

    const product$: Observable<[productTypes[], { fullbrands: productBrands[], allbrands: prontoBrands[] }]> = combineLatest([allproductType$, brands$]).pipe(shareReplay(1));

    //query parameter observable
    const query$: Observable<ISearch> = this.activeRouter.queryParamMap.pipe(
      map((query) => {
        if (query.keys.length > 0 || this.searchField) {
          if (query.has('globalSearch') || query.has('globalSearch2') || this.searchField) {
            return {
              isGlobalSearch: true,
              searchfield: query.get('globalSearch') || query.get('globalSearch2') || this.searchField,
              type: [],
              brand: [],
              category: [],
              series: [],
            };
          } else {
            return {
              isGlobalSearch: false,
              searchfield: query.has('searchfield') ? query.get('searchfield') : '',
              type: query.has('type') ? query.getAll('type') : [],
              brand: query.has('brand') ? query.getAll('brand') : [],
              category: query.has('category') ? query.getAll('category') : [],
              series: query.has('series') ? query.getAll('series') : [],
            };
          }
        } else {
          // this.showProductTypesPage = true;
          // this.showResultPage = false;
          if (this.showResultPage) {
            this.showProductTypesPage = true;
            this.showVendorsPage = false;
            this.showResultPage = false;
          }
          return null;
        }
      }),
    );

    const searchResult$: Observable<ISearchResult> = query$.pipe(
      switchMap((query: ISearch) => {
        if (query) {
          if (query.isGlobalSearch) {
            //global search
            this.showTypeLoading = true;
            this.showBrandLoading = true;
            this.showVendorsPage = false;
            this.showProductTypesPage = false;
            this.showResultPage = true;
            this.loadContent = false;

            this.searchField = query.searchfield;

            //run search first
            this.categories = [];
            this.serieses = [];
            this.selectedTypes = [];
            this.selectedBrands = [];
            this.selectedCategories = [];
            this.selectedSeriese = [];

            this.search(query.searchfield);

            return combineLatest([product$, this.getType$(query.searchfield, ''), this.getBrand$(query.searchfield, '', '', '')]).pipe(
              map(([product, type, brand]) => {
                return {
                  searchType: 'global',
                  keyword: query.searchfield,
                  types: type,
                  brands: brand,
                  categories: [],
                  series: [],
                  selectedCategories: [],
                  selectedSeries: [],
                  selectedBrands: [],
                  selectedTypes: [],

                  allProductTypes: product[0],
                  allBrands: product[1].allbrands,
                  fullBrands: product[1].fullbrands
                } as ISearchResult;
              })
            );

          } else {

            //advanced search
            this.showTypeLoading = true;
            this.showBrandLoading = true;
            this.showVendorsPage = false;
            this.showProductTypesPage = false;
            this.showResultPage = true;
            this.loadContent = false;

            this.searchField = query.searchfield;

            return product$.pipe(
              switchMap(([types, brands]) => {

                const selectedBrands = query.brand;
                const selectedTypes = query.type.map((m) => {
                  return types.find(v => v.out_type_description == m).out_type_code;
                });
                const selectedCategories = query.category;
                const selectedSeries = query.series;
                const keyword = query.searchfield;

                const brandStr = selectedBrands.join(',');
                const typeStr = selectedTypes.join(',');
                const catStr = selectedCategories.join(',');
                const seriesStr = selectedSeries.join(',');

                //type$ filter
                let type$: Observable<productTypes[]>;

                if (selectedBrands.length == 0 && keyword == '') {
                  type$ = of(types);
                } else {
                  type$ = this.getType$(keyword, brandStr);
                }

                //brand$ filter
                let brand$: Observable<productBrands[]>;

                brand$ = this.getBrand$(keyword, typeStr, catStr, seriesStr);

                return combineLatest([type$, brand$]).pipe(
                  switchMap(([type, brand]) => {
                    if (selectedCategories.length > 0 || typeStr != "") {
                      return this.getCategory$(keyword, typeStr, brandStr).pipe(
                        switchMap((cat: productCategories[]) => {
                          if (selectedSeries.length > 0) {
                            return this.getSeries$(keyword, typeStr, brandStr, catStr).pipe(
                              map((series: productSeries[]) => {
                                return {

                                  keyword: keyword,
                                  selectedBrands: selectedBrands,
                                  selectedTypes: selectedTypes,
                                  types: type,
                                  brands: brand,
                                  categories: cat,
                                  series: series,
                                  selectedCategories: selectedCategories,
                                  selectedSeries: selectedSeries,
                                  
                                  searchType: 'advanced',
                                  allProductTypes: types,
                                  allBrands: brands.allbrands,
                                  fullBrands: brands.fullbrands

                                } as ISearchResult;
                              })
                            );
                          } else {
                            const obj = {
                              keyword: keyword,
                              selectedBrands: selectedBrands,
                              selectedTypes: selectedTypes,
                              categories: cat,
                              types: type,
                              brands: brand,
                              series: [],
                              selectedCategories: selectedCategories,
                              selectedSeries: [],

                              searchType: 'advanced',
                              allProductTypes: types,
                              allBrands: brands.allbrands,
                              fullBrands: brands.fullbrands
                            } as ISearchResult;
                            return of(obj);
                          }
                        }));
                    } else {
                      return of({
                        keyword: keyword,
                        selectedBrands: selectedBrands,
                        selectedTypes: selectedTypes,
                        categories: [],
                        series: [],
                        types: type,
                        brands: brand,
                        selectedCategories: [],
                        selectedSeries: [],
                        searchType: 'advanced',
                        allProductTypes: types,
                        allBrands: brands.allbrands,
                        fullBrands: brands.fullbrands
                      } as ISearchResult);
                    }
                  })
                );
              })
            );
          }
        } else {
          //default search
          if (!this.showProductTypesPage && !this.showVendorsPage) {
            this.showProductTypesPage = true;
          }
          this.showTypeLoading = true;
          this.showBrandLoading = true;

          return product$.pipe(
            map(([types, brands]) => {
              return {
                searchType: 'default',
                keyword: '',
                types: [],
                brands: [],
                categories: [],
                series: [],
                selectedCategories: [],
                selectedSeries: [],
                selectedBrands: [],
                selectedTypes: [],

                allProductTypes: types,
                allBrands: brands.allbrands,
                fullBrands: brands.fullbrands
              };
            })
          );
        }
      })
    );

    searchResult$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: ISearchResult) => {
      switch (res.searchType) {
        case 'default':

          this.showTypeLoading = false;
          this.showBrandLoading = false;
          this.loadContent = true;

          this.types = this.allProductTypes = res.allProductTypes;
          this.allBrands = res.allBrands;
          this.brands = this.fullBrands = res.fullBrands;

          this.categories = res.categories;
          this.serieses = res.series;
          this.selectedTypes = res.selectedTypes;
          this.selectedBrands = res.selectedBrands;
          this.selectedCategories = res.selectedCategories;
          this.selectedSeriese = res.selectedSeries;
          break;

        case 'global':

          this.showTypeLoading = false;
          this.showBrandLoading = false;


          this.allProductTypes = res.allProductTypes;
          this.allBrands = res.allBrands;
          this.types = res.types;
          this.brands = res.brands;

          this.categories = res.categories;
          this.serieses = res.series;
          this.selectedTypes = res.selectedTypes;
          this.selectedBrands = res.selectedBrands;
          this.selectedCategories = res.selectedCategories;
          this.selectedSeriese = res.selectedSeries;

          break;

        case 'advanced':
          this.showTypeLoading = false;
          this.showBrandLoading = false;
          this.searchField = res.keyword;


          this.categories = res.categories;
          this.serieses = res.series;
          this.selectedTypes = res.selectedTypes;
          this.selectedBrands = res.selectedBrands;
          this.selectedCategories = res.selectedCategories;
          this.selectedSeriese = res.selectedSeries;

          this.allProductTypes = res.allProductTypes;
          this.allBrands = res.allBrands;
          this.types = res.types;
          this.brands = res.brands;

          this.search(res.keyword);
          break;

        default:
          break;
      }
    });


    // product$.pipe(
    //   tap(() => {
    //     this.showProductTypesPage = true;
    //     this.showVendorsPage = false;
    //     this.showTypeLoading = true;
    //     this.showBrandLoading = true;
    //   })
    // ).takeUntil(this.ngUnsubscribe).subscribe(([types, brands]) => {
    //
    //   this.showTypeLoading = false;
    //   this.showBrandLoading = false;
    //   this.loadContent = true;
    //   this.types = this.allProductTypes = types;
    //   this.allBrands = brands.allbrands;
    //   this.brands = this.fullBrands = brands.fullbrands;
    //
    //   //subscribe query parameter
    //
    //   query$.pipe(
    //     switchMap((query) => {
    //
    //       if (query) {
    //
    //         this.showProductTypesPage = false;
    //         this.showVendorsPage = false;
    //         this.showResultPage = true;
    //         this.loadContent = false;
    //         this.globallySearch = false;
    //
    //         const selectedBrands = query.brand;
    //         const selectedTypes = query.type.map((m) => {
    //           return types.find(v => v.out_type_description == m).out_type_code;
    //         });
    //         const selectedCategories = query.category;
    //         const selectedSeries = query.series;
    //         const keyword = query.searchfield;
    //
    //         const brandStr = selectedBrands.join(',');
    //         const typeStr = selectedTypes.join(',');
    //         const catStr = selectedCategories.join(',');
    //         const seriesStr = selectedSeries.join(',');
    //
    //         //type$ filter
    //         let type$: Observable<productTypes[]>;
    //
    //         if (selectedBrands.length == 0 && keyword=='') {
    //           type$ = Observable.of(this.types);
    //         } else {
    //           type$ = this.getType$(keyword, brandStr);
    //         }
    //
    //         //brand$ filter
    //         let brand$: Observable<productBrands[]>;
    //
    //         brand$ = this.getBrand$(keyword, typeStr, catStr, seriesStr);
    //
    //         return combineLatest(type$, brand$).pipe(
    //           switchMap(([type, brand]) => {
    //             if (selectedCategories.length > 0) {
    //               return this.getCategory$(keyword, typeStr, brandStr).pipe(
    //                 switchMap((cat: productCategories[]) => {
    //                   if (selectedSeries.length > 0) {
    //                     return this.getSeries$(keyword, typeStr, brandStr, catStr).pipe(
    //                       map((series: productSeries[]) => {
    //                         return {
    //                           keyword: keyword,
    //                           selectedBrands: selectedBrands,
    //                           selectedTypes: selectedTypes,
    //                           types: type,
    //                           brands: brand,
    //                           categories: cat,
    //                           series: series,
    //                           selectedCategories: selectedCategories,
    //                           selectedSeries: selectedSeries,
    //                         };
    //                       })
    //                     );
    //                   } else {
    //                     const obj = {
    //                       keyword: keyword,
    //                       selectedBrands: selectedBrands,
    //                       selectedTypes: selectedTypes,
    //                       categories: cat,
    //                       types: type,
    //                       brands: brand,
    //                       series: [],
    //                       selectedCategories: selectedCategories,
    //                       selectedSeries: []
    //                     };
    //                     return Observable.of(obj);
    //                   }
    //                 }));
    //             } else {
    //               return Observable.of({
    //                 keyword: keyword,
    //                 selectedBrands: selectedBrands,
    //                 selectedTypes: selectedTypes,
    //                 categories: [],
    //                 series: [],
    //                 types: type,
    //                 brands: brand,
    //                 selectedCategories: [],
    //                 selectedSeries: [],
    //               });
    //             }
    //             //return Observable.of(null);
    //           })
    //         );
    //
    //       } else {
    //         return Observable.of(null);
    //       }
    //     })
    //   ).takeUntil(this.ngUnsubscribe).subscribe((params: any) => {
    //     if (params) {
    //
    //       this.searchField = params.keyword;
    //
    //       this.types = params.types;
    //
    //       this.brands = params.brands;
    //
    //       this.categories = params.categories;
    //
    //       this.serieses = params.series;
    //
    //       this.selectedTypes = params.selectedTypes;
    //
    //       this.selectedBrands = params.selectedBrands;
    //
    //       this.selectedCategories = params.selectedCategories;
    //
    //       this.selectedSeriese = params.selectedSeries;
    //
    //       // console.log(`types: ${this.types}`);
    //       // console.log(`allProductTypes :${this.allProductTypes}`);
    //
    //       this.search(params.keyword);
    //     }
    //   });
    //
    // });

    // const allbrandType$: Observable<productBrands[]> = this.searchService.getProductSearch('', '', '', '', '', 'brand').pipe(
    //   map((value) => value.map((item) => {
    //       const brand = {} as productBrands;
    //       brand.out_brand_code = item.out_brand_code;
    //       brand.out_brand_description = item.out_brand_description;
    //       brand.brand_description_with_cnt = `${item.out_brand_description} (${item.cnt})`;
    //       brand.cnt = item.cnt;
    //       return brand;
    //     })
    //   ));


    // get full product type list
    //this.browseByProductType();

    this.getCurrentViewOption();
    // this.getCurrentCartId();
    this.store.select(getSelectedShoppingCart).subscribe(cart => {
      if (cart) {
        this.cartId = cart.cartId;
      }
    });

    this._actions$.pipe(ofType(ShoppingCartActionTypes.InsertShoppingCartItemSuccess, ShoppingCartActionTypes.LoadShoppingCartFailure)).subscribe(() => {
      this.addingItemId = '';
    })
    // if it does not have any param for searchfiled, avoid to call them twice
    // if (!this.router.url.includes('searchfield')) {
    //
    //   this.browseByBrands(); // get full brands list
    // }


    //vendor and type filter

    // this.activeRouter.queryParamMap.takeUntil(this.ngUnsubscribe).subscribe((query) => {
    //
    //   //query.type
    //   this.selectedTypes = query.has('type') ? this.mapTypeDesctoCode(query.getAll('type')) : [];
    //   //query.brand
    //   this.selectedBrands = query.has('brand') ? query.getAll('brand') : [];
    //   //query.category
    //   this.selectedCategories = query.has('category') ? query.getAll('category') : [];
    //   //query.series
    //   this.selectedSeriese = query.has('series') ? query.getAll('series') : [];
    //
    //   this.searchField = query.has('searchfield') ? query.get('searchfield') : '';
    //
    //   const showresult = query.get('showresult');
    //
    //   if (showresult) {
    //     this.showResultPage = true;
    //     this.updateBreadcrumb('results');
    //   }
    //
    //   this.showFilter=true;
    //
    //   this.search(this.searchField);
    //
    // });

    // this.activeRouter.queryParamMap.subscribe(param => {
    //     const showresult = param.get('showresult');
    //     const searchfield = param.get('searchfield');
    //
    //     this.getCurrentViewOption();
    //
    //     if (showresult) {
    //         this.showResultPage = true;
    //         this.updateBreadcrumb('results');
    //     }
    //
    //     if (searchfield) {
    //
    //         this.searchField = decodeURIComponent(searchfield);
    //         const isGlobalSearch = true;
    //         this.filterReset(isGlobalSearch);
    //
    //         this.search(searchfield);
    //
    //         this.showFilter = true;
    //         this.updateBreadcrumb('results');
    //     }
    // });

    this.activeRouter.url.subscribe(value => {
      if (value.length === 0) {
        $('.page-contents').animate({ scrollLeft: 0 }, 400);
      }
    });

    // show product page
    if (this.router.url.includes('/product/')) {
      this.showProductTypesPage = false;
      this.showVendorsPage = false;
      this.showResultPage = false;
    }

  }

  closeComponent() {
    this.router.navigate(['/home']);
  }

  onKeywordChange(value: any) {
    this.keywordSubject.next(value);
  }

  getType$(keyword: string, brand: string): Observable<productTypes[]> {
    return this.searchService.getProductSearch(encodeURIComponent(keyword), brand, '', '', '', 'type').pipe(
      map((value) => {
        return value?.map(item => {
          const type = {} as productTypes;
          type.out_type_code = item.out_type_code;
          type.out_type_description = item.out_type_description;
          type.type_description_with_cnt = `${item.out_type_description} (${item.cnt})`;
          type.cnt = item.cnt;
          return type;
        });
      })
    );
  }

  getBrand$(keyword: string, type: string, cat: string, series: string): Observable<productBrands[]> {
    return this.searchService.getProductSearch(encodeURIComponent(keyword), '', type, cat, series, 'brand').pipe(
      map((value) => {
        return value?.map(item => {
          const brand = {} as productBrands;
          brand.out_brand_code = item.out_brand_code;
          brand.out_brand_description = item.out_brand_description;
          brand.brand_description_with_cnt = `${item.out_brand_description} (${item.cnt})`;
          brand.cnt = item.cnt;
          return brand;
        });
      })
    );
  }

  getCategory$(keyword: string, type: string, brand: string): Observable<productCategories[]> {
    return this.searchService.getProductSearch(encodeURIComponent(keyword), brand, type, '', '', 'category').pipe(
      map((value) => {
        return value?.map(item => {
          const cat = {} as productCategories;
          cat.out_category = item.out_category;
          cat.out_category_cnt = item.cnt;
          cat.category_with_cnt = `${item.out_category} (${item.cnt})`;
          return cat;
        });
      })
    );
  }

  getSeries$(keyword: string, type: string, brand: string, cat: string): Observable<productSeries[]> {
    return this.searchService.getProductSearch(encodeURIComponent(keyword), brand, type, cat, '', 'series').pipe(
      map((value) => {
        return value?.map(item => {
          const series = {} as productSeries;
          series.out_series = item.out_series;
          series.out_series_cnt = item.cnt;
          series.series_with_cnt = `${item.out_series} (${item.cnt})`;
          return series;
        });
      })
    );
  }

  advancedSearch(): void {
    // {'type':mapTypeCodetoDesc(selectedTypes),'brand':selectedBrands,'category':selectedCategories,'series':selectedSeriese,'searchfield':searchField}
    const params = {} as any;

    if (this.selectedTypes.length > 0) {
      const desc = [];
      if (this.selectedTypes.length > 0) {
        this.selectedTypes.forEach(m => {
          const type = this.types.find(x => x.out_type_code == m);
          desc.push(type.out_type_description);
        });
      }
      params.type = desc;
    }
    if (this.selectedBrands.length > 0) {
      params.brand = this.selectedBrands;
    }
    if (this.selectedCategories.length > 0) {
      params.category = this.selectedCategories;
    }
    if (this.selectedSeriese.length > 0) {
      params.series = this.selectedSeriese;
    }
    if (this.searchField) {
      params.searchfield = this.searchField;
    }
    // this.router.navigate(['/buy'], {queryParams: params});
    // update URL & trigger search to avoid reload the entire search fields
    this.showVendorsPage = false;
    this.showProductTypesPage = false;
    this.showResultPage = true;
    this.loadContent = false;
    let url = this.router.createUrlTree(['/buy'], { queryParams: params }).toString();
    this.location.go(url);
    this.search(this.searchField);
  }

  getCurrentViewOption() {
    if (localStorage.getItem('viewoption')) {
      this.selectedViewOption = localStorage.getItem('viewoption');
    } else {
      this.selectedViewOption = 'advanced';
    } 
    
 }

  onChangeView() {
    this.loadContent = false;
    setTimeout(() => {
      localStorage.setItem('viewoption', this.selectedViewOption);
      this.loadContent = true;
      this.commonService.applyScrollFixedHeader(this.parentWrapper);
    },100);
  }

  search(field: string) {
    // this.showProductTypesPage = false;
    // this.showVendorsPage = false;
    // this.showResultPage = true;
    // this.loadContent = false;
    //this.globallySearch = false;
    this.brandsParam = '';
    this.typesParam = '';
    this.catsParam = '';
    this.seriesParam = '';
    this.filterInput = '';
    this.bannerList = [];

    if (field.length === 0 && !this.selectedBrands.length && !this.selectedTypes.length) {
      return;
    }
    // Get the params & headers
    if (this.selectedBrands.length) {
      if (this.selectedBrands.length > 10 && this.selectedBrands.length === this.brands.length) {
        this.selectedBrandsString = 'All';
      } else {
        const selectedArray = this.brands.filter(item => this.selectedBrands.indexOf(item.out_brand_code) > -1).map((i) => i.out_brand_description);
        this.selectedBrandsString = selectedArray.join(', ');
      }
      this.brandsParam = this.selectedBrands.join(',');
    }
    if (this.selectedTypes.length) {
      if (this.selectedTypes.length > 10 && this.selectedTypes.length === this.types.length) {
        this.selectedTypesString = 'All';
      } else {
        const selectedArray = this.types.filter(item => this.selectedTypes.indexOf(item.out_type_code) > -1).map((i) => i.out_type_description);
        this.selectedTypesString = selectedArray.join(', ');
      }
      this.typesParam = this.selectedTypes.join(',');

    }
    if (this.selectedCategories.length) {
      this.catsParam = this.selectedCategories.join(',');
      if (this.selectedCategories.length > 10 && this.selectedCategories.length === this.categories.length) {
        this.selectedCategoriesString = 'All';
      } else {
        this.selectedCategoriesString = this.catsParam;
      }

    }
    if (this.selectedSeriese.length) {
      this.seriesParam = this.selectedSeriese.join(',');
      if (this.selectedSeriese.length > 10 && this.selectedSeriese.length === this.serieses.length) {
        this.selectedSeriesString = 'All';
      } else {
        this.selectedSeriesString = this.seriesParam;
      }
    }

    const minprice = this.minPrice ? this.minPrice.toString() : '';
    const maxprice = this.maxPrice ? this.maxPrice.toString() : '';
    const minsoh = this.minSOH ? this.minSOH.toString() : '';
    const excludeKits = this.excludeKits ? true : false;

    this.searchedKeyword = field.trim();

    this.searchService.retrieve(field.trim(), this.brandsParam, this.typesParam, this.catsParam, this.seriesParam, minprice, maxprice, minsoh, excludeKits).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((values: any) => {

        this.searchResult = values.data;
        this.metaData = values.meta;

        // set the dropdown list value for filters after global search
        if (this.metaData != null && !this.selectedBrands.length && !this.selectedTypes.length && !this.selectedCategories.length) {

          // let returnedBrandsArray = this.metaData.brand.map(i => { return i.lr_stk_brand });
          // this.brands = this.brands.filter(i => returnedBrandsArray.indexOf(i.out_brand_code) > -1);
          const fullBrands = this.brands.slice();
          this.brands = this.metaData.brand.map(item => {
            const brand = {} as productBrands;
            brand.out_brand_code = item.lr_stk_brand;
            brand.out_brand_description = fullBrands.filter(x => x.out_brand_code === item.lr_stk_brand)[0].out_brand_description;
            brand.brand_description_with_cnt = `${brand.out_brand_description} (${item.lr_count})`;
            brand.cnt = item.lr_count;
            return brand;
          });

          // let returnedTypesArray = this.metaData.primary.map(i => { return i.lr_primary_cat });
          // this.types = this.types.filter(i => returnedTypesArray.indexOf(i.out_type_description) > -1);
          const fullTypes = this.types.slice();
          this.types = this.metaData.primary.map(item => {
            const type = {} as productTypes;
            type.out_type_code = fullTypes.filter(x => x.out_type_description === item.lr_primary_cat)[0].out_type_code;
            type.out_type_description = item.lr_primary_cat;
            type.type_description_with_cnt = `${item.lr_primary_cat} (${item.lr_count})`;
            type.cnt = item.lr_count;
            return type;
          });

          this.categories = this.metaData.secondary.map(item => {
            const cat = {} as productCategories;
            cat.out_category = item.lr_secondary_cat.trim();
            cat.category_with_cnt = `${item.lr_secondary_cat.trim()} (${item.lr_count})`;
            cat.out_category_cnt = item.lr_count;
            return cat;
          });


          this.serieses = this.metaData.tertiary.map(item => {
            const series = {} as productSeries;
            series.out_series = item.lr_tertiary_cat.trim();
            series.series_with_cnt = `${item.lr_tertiary_cat.trim()} (${item.lr_count})`;
            series.out_series_cnt = item.lr_count;
            return series;
          });


          // this.selectedBrands = this.metaData.brand.map(item => {return item.lr_stk_brand});
          // this.selectedTypes = this.types.filter(i => returnedTypesArray.indexOf(i.out_type_description) > -1).map(item => {return item.out_type_code});
          // this.selectedCategories = this.metaData.secondary.map(item => {return item.lr_secondary_cat.trim() });
          // this.selectedSeriese = this.metaData.tertiary.map(item => { return item.lr_tertiary_cat.trim() });
          // this.getProductCategories();
          // this.getProductSeries();

          this.globallySearch = true;

        }

        if (this.searchResult && this.searchResult.length > 0) {
          this.sortedData = this.searchResult.slice();
          this.withoutBundleData = this.sortedData;

          this.sortedData.forEach(item => {
            item.encodedStockCode = this.cs.DDskuEncode(item.lr_stock_code);
          });
          this.hasEmptyFilterResult = false;
          this.hasEmptyResult = false;
          this.commonService.applyScrollFixedHeader(this.parentWrapper);
        } else {
          this.hasEmptyFilterResult = true;
          this.hasEmptyResult = true;
        }
        this.configureData();
        // this.globallySearch = true;
        this.getBanners();

        this.setInputQtyArr();

        this.loadContent = true;

      },
        (error: any) => {
          console.error(error);
        });
  }

  showWithoutBundle(event: any): void {
    this.sortedData=this.withoutBundleData;
    if (!event.checked) {
      this.isWithoutBundle = event.checked;
      if (this.isShowWithStock == true) {
        const data = this.sortedData.filter(x => x.lr_avail_qty != '0' && x.lr_stock_type != 'K');
        this.sortedData = data;
      } else {
        this.isWithoutBundle = event.checked;
        const data = this.sortedData.filter(x => x.lr_stock_type != 'K');
        this.sortedData = data;
      }
    } else {
      this.isWithoutBundle = event.checked;
      if (this.isShowWithStock == true) {
        const data = this.sortedData.filter(x => x.lr_avail_qty != '0');
        this.sortedData = data;
      } else {
        this.isWithoutBundle = event.checked;
        /* const data = this.sortedData.filter(x => x.lr_stock_type== 'K' && x.lr_avail_qty == '0');
        this.sortedData = data; */
        this.isWithoutBundle = event.checked;
      }
    }
    this.sortAfterBundle();
  }

  sortAfterBundle()
  {
     
     if(this.selectedSortOrder)
     {
        this.sortedData = this.sortedData.sort((a, b) => {
          const isAsc = this.selectedSortOrder.direction === 'asc';
          switch (this.selectedSortOrder.active) {
            case 'des':
            return compare(a.lr_stk_description, b.lr_stk_description, isAsc);
            // tslint:disable-next-line:radix
            case 'soh':
              return compare(parseInt(a.lr_avail_qty), parseInt(b.lr_avail_qty), isAsc);
            case 'price':
              return compare(parseFloat(a.lr_stk_price), parseFloat(b.lr_stk_price), isAsc);
            case 'qty':
              return compare(a.lr_stock_code, b.lr_stock_code, isAsc);
            case 'brand':
              return compare(a.lr_stk_brand, b.lr_stk_brand, isAsc);
            case 'code':
              return compare(a.lr_stock_code, b.lr_stock_code, isAsc);
            default:
              return 0;
          }
        });
     }
  }

  showSOH(event: any): void {
    this.sortedData=this.withoutBundleData;
    if (!event.checked) {
      this.isShowWithStock = event.checked;
      if (this.isWithoutBundle == true) {
        /* const data = this.sortedData.filter(x => x.lr_stock_type == 'K');
        this.sortedData = data; */
        this.sortedData = this.withoutBundleData;
      }      
      else{
        const data = this.sortedData.filter(x => x.lr_stock_type != 'K');
        this.sortedData = data;
      }
    }
    else {
      if (this.isWithoutBundle == true) {
        this.isShowWithStock = event.checked;
      const data = this.sortedData.filter(x => x.lr_avail_qty != '0');
      this.sortedData = data;
      }
      else{
        this.isShowWithStock = event.checked;
        const data = this.sortedData.filter(x => x.lr_avail_qty != '0' && x.lr_stock_type != 'K');
        this.sortedData = data;
      }
      
    }
  }

  configureData()
  {
    let dataToBeConfigure = [...this.withoutBundleData];
    if(this.isWithoutBundle && this.isShowWithStock)
    {
      this.sortedData = dataToBeConfigure.filter(x => x.lr_avail_qty != '0');
    }
    else if(!this.isWithoutBundle && this.isShowWithStock)
    {
      this.sortedData = dataToBeConfigure.filter(x => x.lr_avail_qty != '0' && x.lr_stock_type != 'K');
    }
    else if(this.isWithoutBundle && !this.isShowWithStock)
    {
      this.sortedData = dataToBeConfigure;
    }
    else if(!this.isWithoutBundle && !this.isShowWithStock)
    {
      this.sortedData = dataToBeConfigure.filter(x => x.lr_stock_type != 'K');
    }
  }

  getCurrentCartId() {
    this.shoppingCartService.currentCartId.pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(value => {
        this.cartId = value;
      },
        (error: any) => {
          console.error(error);
        });
  }

  getProductBrands(): void {
    if (this.globallySearch) {
      return;
    }

    if (this.fullBrands.length > 0 && this.selectedTypes.length === 0 && this.searchField === '') { // get cached full brands if there is no params
      this.brands = this.fullBrands;
      this.selectedBrands = this.brands.filter(i => this.selectedBrands.indexOf(i.out_brand_code) > -1).map(item => item.out_brand_code);
      return;
    }

    this.showBrandLoading = true;
    const typesParam = this.selectedTypes.length > 0 ? this.selectedTypes.join(',') : '';
    const catsParam = this.selectedTypes.length > 0 && this.selectedCategories.length > 0 ? this.selectedCategories.join(',') : '';
    const seriesParam = this.selectedTypes.length > 0 && this.selectedCategories.length > 0 && this.selectedSeriese.length > 0 ? this.selectedSeriese.join(',') : '';

    this.searchService.getProductSearch(encodeURIComponent(this.searchField), '', typesParam, catsParam, seriesParam, 'brand').pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((value: getProductSearch[]) => {
        this.brands = value?.map(item => {
          const brand = {} as productBrands;
          brand.out_brand_code = item.out_brand_code;
          brand.out_brand_description = item.out_brand_description;
          brand.brand_description_with_cnt = `${item.out_brand_description} (${item.cnt})`;
          brand.cnt = item.cnt;
          return brand;
        });

        // cached the full types
        if (this.searchField === '' && typesParam === '' && catsParam === '' && seriesParam === '') {
          this.fullBrands = this.brands;
        }

        this.selectedBrands = this.selectedBrands ? this.brands?.filter(i => this.selectedBrands.indexOf(i.out_brand_code) > -1).map(item => item.out_brand_code) : [];

        this.showBrandLoading = false;
      },
        (error: any) => {
          console.error(error);
          this.showBrandLoading = false;
        });
  }

  getProductType(): void {
    if (this.globallySearch) {
      return;
    }
    if (this.allProductTypes.length > 0 && this.selectedBrands.length === 0 && this.searchField === '') { // get cached full types if there is no params
      this.types = this.allProductTypes;
      this.selectedTypes = this.types.filter(i => this.selectedTypes.indexOf(i.out_type_code) > -1).map(item => item.out_type_code);
      return;
    }


    const brandsParam = this.selectedBrands.length > 0 ? this.selectedBrands.join(',') : '';
    this.searchService.getProductSearch(encodeURIComponent(this.searchField), brandsParam, '', '', '', 'type').pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((value: getProductSearch[]) => {
        this.types = value.map(item => {
          const type = {} as productTypes;
          type.out_type_code = item.out_type_code;
          type.out_type_description = item.out_type_description;
          type.type_description_with_cnt = `${item.out_type_description} (${item.cnt})`;
          type.cnt = item.cnt;
          return type;
        });

        if (this.searchField === '' && brandsParam === '') {  // cached the full types
          this.allProductTypes = this.types;
        }

        this.selectedTypes = this.types.filter(i => this.selectedTypes.indexOf(i.out_type_code) > -1).map(item => item.out_type_code);

      },
        (error: any) => {
          console.error(error);
          this.showTypeLoading = false;
        });
  }

  getProductCategories(): void {

    if (this.selectedTypes.length > 0 && !this.globallySearch) {
      this.showCategoryLoading = true;
      const typesParam = this.selectedTypes.length > 0 ? this.selectedTypes.join(',') : '';
      const brandsParam = this.selectedBrands.length > 0 ? this.selectedBrands.join(',') : '';

      this.searchService.getProductSearch(encodeURIComponent(this.searchField), brandsParam, typesParam, '', '', 'category').pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((value: getProductSearch[]) => {
          this.categories = value.map(item => {
            const cat = {} as productCategories;
            cat.out_category = item.out_category;
            cat.out_category_cnt = item.cnt;
            cat.category_with_cnt = `${item.out_category} (${item.cnt})`;
            return cat;
          });

          this.selectedCategories = this.categories.filter(i => this.selectedCategories.indexOf(i.out_category) > -1).map(item => item.out_category);

          this.showCategoryLoading = false;
        },
          (error: any) => {
            console.error(error);
            this.showCategoryLoading = false;
          });
    } else {
      this.selectedCategories = [];
    }
  }

  getProductSeries(): void {

    if (this.selectedTypes.length > 0 && this.selectedCategories.length > 0 && !this.globallySearch) {
      this.showSeriesLoading = true;
      const typeParam = this.selectedTypes.join(',');
      const catParam = this.selectedCategories.join(',');
      const brandsParam = this.selectedBrands.length > 0 ? this.selectedBrands.join(',') : '';

      this.searchService.getProductSearch(encodeURIComponent(this.searchField), brandsParam, typeParam, catParam, '', 'series').pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((value: getProductSearch[]) => {
          this.serieses = value?.map(item => {
            const series = {} as productSeries;
            series.out_series = item.out_series;
            series.out_series_cnt = item.cnt;
            series.series_with_cnt = `${item.out_series} (${item.cnt})`;
            return series;
          });

          this.selectedSeriese = this.serieses?.filter(i => this.selectedSeriese.indexOf(i.out_series) > -1).map(item => item.out_series);

          this.showSeriesLoading = false;
        },
          (error: any) => {
            console.error(error);
            this.showSeriesLoading = false;
          });
    } else {
      this.selectedSeriese = [];
    }

  }

  // called when the mat-select has any changes.
  updateFilterList(filterType: string) {

    switch (filterType) {
      case 'keyword':
        this.getProductType();
        this.getProductCategories();
        this.getProductSeries();
        this.getProductBrands();
        break;
      case 'brand':
        this.getProductType();
        this.getProductCategories();
        this.getProductSeries();
        break;
      case 'type':
        this.getProductBrands();
        this.getProductCategories();
        this.getProductSeries();
        break;
      case 'category':
        this.getProductBrands();
        this.getProductSeries();
        break;
      case 'series':
        this.getProductBrands();
        break;
    }

  }

  onSelectAll(filterType: string) {

    switch (filterType) {
      case 'brand':
        if (this.brands.length) {
          this.selectedBrands = this.brands.map((item) => item.out_brand_code);
        }
        break;
      case 'type':
        if (this.types.length) {
          this.selectedTypes = this.types.map((item) => item.out_type_code);
        }
        break;
      case 'category':
        if (this.categories.length) {
          this.selectedCategories = this.categories.map((item) => item.out_category);
        }
        break;
      case 'series':
        if (this.serieses.length) {
          this.selectedSeriese = this.serieses.map((item) => item.out_series);
        }
        break;
    }

    this.updateFilterList(filterType);
  }

  onClearAll(filterType: string) {
    switch (filterType) {
      case 'brand':
        this.selectedBrands = [];
        break;
      case 'type':
        this.selectedTypes = [];
        this.selectedCategories = [];
        this.selectedSeriese = [];
        break;
      case 'category':
        this.selectedCategories = [];
        break;
      case 'series':
        this.selectedSeriese = [];
        break;

    }

    this.updateFilterList(filterType);
  }

  onChange() {
    this.sortedData = new TablefilterMultiplePipe().transform(this.searchResult.slice(), ['lr_primary_cat', 'lr_secondary_cat', 'lr_std_price', 'lr_stk_brand', 'lr_stk_description', 'lr_stock_code', 'lr_tertiary_cat', 'lr_stock_group'], this.filterInput);
    if (this.sortedData.length === 0) {
      this.hasEmptyFilterResult = true;

    } else {
      this.hasEmptyFilterResult = false;
    }
  }

  setInputQtyArr() {
    if (this.searchResult) {
      for (let i = 0; i < this.searchResult.length; i++) {
        this.inputQtyArr[this.searchResult[i]['lr_stock_code']] = '1';
      }
    }
  }

  sohLoad(current: string, max: string): string {
    return getStockOnHand(current, max, null, null, null);
  }

  addToCart(event: any, brandItem: BrandListReturn) {
    this.addingItemId = brandItem.encodedStockCode;
    this.store.dispatch(new InsertShoppingCartItem({
      stockCode: encodeURIComponent(brandItem.lr_stock_code),
      cartId: this.cartId,
      Qty: this.inputQtyArr[brandItem.lr_stock_code]
    }));
    // event.stopPropagation();
    // event.preventDefault();
    // this.shoppingCartService.addItemToShoppingCart(encodeURIComponent(brandItem.lr_stock_code), this.cartId, this.inputQtyArr[brandItem.lr_stock_code]).subscribe((data: ApiResponse) => {
    //     if (data.status) {
    //         this.commonService.implementToast(data.responseMessage, 'Success');

    //         this.shoppingCartService
    //             .getShoppingCart()
    //             .subscribe((sc: ShoppingCart[]) => {
    //                 this.shoppingCartService.setCacheShoppingCart(sc);
    //                 this.shoppingCartService.monitorNumberOfItemsChange(sc.filter(cart => cart.cartId === this.cartId)[0].totalQuantity);
    //             },
    //                 (error: any) => {
    //                     console.error(error);
    //                 });
    //     } else {
    //         this.commonService.implementToast(data.responseMessage, 'Error');

    //     }
    // },
    //     (error: any) => {
    //         this.commonService.implementToast(error.responseMessage, 'Error');

    //     });
  }

  sortData(sort: Sort) {
    this.selectedSortOrder = sort;
    let data = this.searchResult.slice();
    if (!sort.active || sort.direction === '') {
      // this.sortedData = data;
    }
      if(this.isShowWithStock)
      {
      data = data.filter(x => x.lr_avail_qty != '0');
      }
    this.sortedData = this.sortedData.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      
      switch (sort.active) {
        case 'des':
          return compare(a.lr_stk_description, b.lr_stk_description, isAsc);
        // tslint:disable-next-line:radix
        case 'soh':
          const aSOH = (Number.parseInt(a.lr_max_avail_qty) < Number.parseInt(a.lr_avail_qty) && Number.parseInt(a.lr_max_avail_qty) != 0) ?
            Number.parseInt(a.lr_max_avail_qty) : Number.parseInt(a.lr_avail_qty);
          const bSOH = (Number.parseInt(b.lr_max_avail_qty) < Number.parseInt(b.lr_avail_qty) && Number.parseInt(b.lr_max_avail_qty) != 0) ?
            Number.parseInt(b.lr_max_avail_qty) : Number.parseInt(b.lr_avail_qty);
          return compare(aSOH, bSOH, isAsc);
        case 'price':
          return compare(parseFloat(a.lr_stk_price), parseFloat(b.lr_stk_price), isAsc);
        case 'qty':
          return compare(a.lr_stock_code, b.lr_stock_code, isAsc);
        case 'brand':
          return compare(a.lr_stk_brand, b.lr_stk_brand, isAsc);
        case 'code':
          return compare(a.lr_stock_code, b.lr_stock_code, isAsc);
        default:
          return 0;
       }
     });
  }

  filterReset(isGlobalSearch: boolean): void {

    this.selectedBrands = [];
    this.selectedTypes = [];
    this.selectedCategories = [];
    this.selectedSeriese = [];
    this.brandsParam = '';
    this.typesParam = '';
    this.catsParam = '';
    this.seriesParam = '';
    this.selectedBrandsString = '';
    this.selectedTypesString = '';
    this.selectedCategoriesString = '';
    this.selectedSeriesString = '';
    this.showProductTypesPage = false;
    this.showVendorsPage = false;
    if (!isGlobalSearch) {
      this.showResultPage = false;
      this.showProductTypesPage = true;
      this.updateBreadcrumb('types');
    }

    if (!isGlobalSearch) {
      this.searchField = '';
    }
    this.minPrice = null;
    this.maxPrice = null;
    this.minSOH = null;
    this.excludeKits = false;
    this.globallySearch = false;


    this.getProductType();
    this.getProductBrands();

  }

  downloadExcel(): void {
    if (this.showResultDownloading || (this.searchField.length === 0 && !this.selectedBrands.length && !this.selectedTypes.length)) {
      return;
    }
    this.showResultDownloading = true;
    this.commonService.implementToast('Product Search Result CSV will be downloaded shortly', 'Info');
    this.searchService.getSearchResultDownloadLink(this.searchField, this.brandsParam, this.typesParam, this.catsParam, this.seriesParam).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: string) => {
        if (res) {
          this.downloadLink = res;
          window.location.href = this.downloadLink;
          this.showResultDownloading = false;
        }
      },
        (error: any) => {
          console.error(error);
          this.commonService.implementToast('Product Search Result CSV failed', 'Error');
          this.showResultDownloading = false;
        });
  }

  copyDownloadLink() {
    if (this.searchField.length === 0 && !this.selectedBrands.length && !this.selectedTypes.length) {
      return;
    }
    this.commonService.implementToast('Product Search Result CSV will be downloaded shortly', 'Info');
    this.searchService.getSearchResultDownloadLink(this.searchField, this.brandsParam, this.typesParam, this.catsParam, this.seriesParam).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: string) => {
        if (res) {
          const downloadURL = document.location.protocol + '//' + document.location.hostname + res;
          this.copyToClipboard(downloadURL);
          this.commonService.implementToast('Product search result link copied to clipboard successfully', 'Success');
        }
      },
        (error: any) => {
          console.error(error);
          this.commonService.implementToast('Get product search result download url failed', 'Error');
        });
  }

  copyToClipboard(item: any): void {
    const listener = (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', (item));
      e.preventDefault();
    };
    document.addEventListener('copy', listener);
    document.execCommand('copy');
    document.removeEventListener('copy', listener);
  }

  ngOnDestroy(): void {
    this.commonService.emitUpdateSideBarActiveItem('');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  sendFeedback(event: any) {
    event.stopPropagation();
    this.messageService.filter('feedback');
  }

  onLoading(currentLoadingStatus: boolean) {

    this.loadContent = !currentLoadingStatus;
  }

  tryAgain() {
    this.filterReset(false);
    this.closeResultsPage();
  }

  close() {    
    this.entry.clear();
    this.created = false;
  }

  closeResultsPage() {
    this.router.navigateByUrl('/buy');
    this.filterReset(false);
    this.showResultPage = false;
    this.showVendorsPage = this.isBrowseByVendor ? true : false;
    this.showProductTypesPage = !this.isBrowseByVendor ? true : false;
    if (this.showVendorsPage) {
      this.updateBreadcrumb('brands');
    } else if (this.showProductTypesPage) {
      this.updateBreadcrumb('types');
    } else {
      this.updateBreadcrumb('');
    }
  }

  checkProductDetail(stockCode: string): void {
    stockCode = encodeURIComponent(stockCode);
    this.showResultPage = true;
    this.router.navigate([`product/${stockCode}`], { relativeTo: this.activeRouter, queryParamsHandling: 'preserve' });
  }

  sendEnquiry(brandItem: BrandListReturn): void {
    this.dialog.open(SendEnquiryComponent, {
      panelClass: 'mat-dialog-wrapper',
      width: '650px',
      data: { item: brandItem }
    });
  }

  onChangeBrowsePage(browseType: string): void {
    this.showResultPage = false;
    this.filterReset(false);
    if (browseType === 'type') {
      //this.browseByProductType();
      this.isBrowseByVendor = false;
      this.updateBreadcrumb('types');
    } else {  // browse by brands
      this.isBrowseByVendor = true;
      this.showProductTypesPage = false;
      this.showVendorsPage = true;
      //this.browseByBrands();
      this.updateBreadcrumb('brands');
    }
  }

  updateBreadcrumb(type: string, subType?: string): void {
    this.breadcrumbItems = [];
    // set default breadcrumb
    const defualtitem = {} as IBreadcrumb;
    defualtitem.label = 'Search Products';
    // defualtitem.url = '/buy';
    this.breadcrumbItems.push(defualtitem);

    if (type === 'types') {
      const item = {} as IBreadcrumb;
      item.label = 'Browse by Product Type';
      item.url = '/buy';
      item.params = ['showProductTypes', true];
      this.breadcrumbItems.push(item);
    } else if (type === 'brands') {
      const item = {} as IBreadcrumb;
      item.label = 'Browse by Vendors';
      item.url = '/buy';
      item.params = ['showVendors', true];
      this.breadcrumbItems.push(item);
    } else if (type === 'results') {
      const item = {} as IBreadcrumb;
      item.label = 'Results';
      this.breadcrumbItems.push(item);
    }

    if (subType && subType !== '') {
      const item = {} as IBreadcrumb;
      item.label = subType;
      item.url = '';
      this.breadcrumbItems.push(item);
    }

    this.breadcrumbService.setBreadCrumb(this.breadcrumbItems);
  }

  sendBrandEnquiry(brandItem: prontoBrands): void {
    const brandListItem = {} as BrandListReturn;
    brandListItem.lr_stk_brand = brandItem.lrBrandName;
    brandListItem.lr_stock_code = '';
    brandListItem.lr_stk_description = '';
    this.dialog.open(SendEnquiryComponent, {
      panelClass: 'mat-dialog-wrapper',
      width: '650px',
      data: { item: brandListItem }
    });
  }

  getBanners() {

    const locationId = this.commonService.getBannerLocationId('searchresult');
    const bannerQuantity = (this.searchResult && this.searchResult.length > this.bannerInterval) ? (this.searchResult.length / this.bannerInterval) : 1;
    this.marketingService.getPromotionList('B', locationId, Math.floor(bannerQuantity)).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((result: Promotion[]) => {
        if (result && result.length > 0) {
          this.bannerList = result;
          // this.randomBanners = result;
          // this.bannerCount = this.bannerList.length;
          // this.randomBanners = this.shuffle(this.bannerList);
        }
      },
        (error: any) => {
          console.error(error);
        });

  }

  shuffle(array) {
    let currentIndex = array.length, temporaryValue, randomIndex;
    while (0 !== currentIndex) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }
    return array;
  }

  typeStartsWithSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.type_description_with_cnt.toLocaleLowerCase().startsWith(term);
  }

  catStartsWithSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.category_with_cnt.toLocaleLowerCase().startsWith(term);
  }

  seriesStartsWithSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.series_with_cnt.toLocaleLowerCase().startsWith(term);
  }

  brandStartsWithSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.brand_description_with_cnt.toLocaleLowerCase().startsWith(term);
  }

  public navToDetailPage(sku: string, event): void {
    if (event.ctrlKey) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    // error sku case: 'DS423+-32TB-EXOS'
    // '/'
    // let plainSKU = sku.includes('%2F') ? sku : this.commonService.DDskuDecode(sku);
    // this.router.navigateByUrl(
    //   this.router.createUrlTree(
    //     [`/buy/product/${plainSKU}`], { queryParamsHandling: 'preserve' }
    //   )
    // );

    if (sku.includes('(') || sku.includes(')')) {
      sku = this.commonService.manuallyEncodingBrackets(sku);
    }      
    this.router.navigate([`/buy/product/${sku}`], { queryParamsHandling: "merge" });

    // this.router.navigateByUrl(
    //   `/buy/product/${sku}`
    // );
  }
 
  public getproducturl(sku: string): string {
    if (sku.includes('(') || sku.includes(')')) {
      sku = this.commonService.manuallyEncodingBrackets(sku);
    }    
    return this.router.serializeUrl(this.router.createUrlTree([`/buy/product/${sku}`], { queryParamsHandling: "merge" }));
  }

}

function compare(a, b, isAsc) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

